/*
 * PLEASE NOTE
 * The purpose of this file is to allow the Pamper's Registration Modal
 * to be utilized outside the Registry App.
 * */

import React from 'react'
import { Provider } from 'react-redux'
import { PampersRegistrationModal } from '../registry/modals'
import PampersRewardLink from '../registry/components/pampers-reward-link'
import * as actions from '../registry/actions'
import registryReducer from '../registry/reducers'
import { applyMiddleware, combineReducers, createStore } from 'redux'
import thunk from 'redux-thunk'
import { createLogger } from 'redux-logger'

let middlewares = [thunk]

if (process.env.NODE_ENV === 'development') {
  // middlewares.push(createLogger())
}

const createStoreWithMiddleware = applyMiddleware(...middlewares)(createStore)

export default class PampersRegistrationModalLegacyAdapter extends React.Component {
  constructor(props) {
    super(props)

    this.store = createStoreWithMiddleware(combineReducers(registryReducer))

    this.store.dispatch(actions.setUser(props.user))
    this.store.dispatch(actions.setRegistry(props.registry))
  }

  render() {
    return (
      <Provider store={this.store}>
        <div>
          <PampersRegistrationModal />
          <PampersRewardLink />
        </div>
      </Provider>
    )
  }
}
